module.exports = __webpack_public_path__ + "img/km.9b06043d.svg";